import * as errorHandler from 'redux/actions/error';
import apiService from 'shared/services/ApiService';

import { SET_LIST_AGGREGATOR, PROCESSING } from './types';

const { allBillerApiService } = apiService.getInstance();

export const setListAggregator = (payload, filter) => ({
  type: SET_LIST_AGGREGATOR,
  payload,
  filter,
});

export const getListAggregator = params => async dispatch => {
  dispatch({ type: PROCESSING });

  try {
    const response = await allBillerApiService.get('aggregators', { params });
    if (response.status === 200) {
      const { payload } = response.data;
      dispatch(aggregator.setListAggregator(payload, params));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
  }
};

const aggregator = {
  setListAggregator,
  getListAggregator,
};

export default aggregator;
